import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

type AddedItem = {
  name: string;
  price: number;
};

type Cart = {
  baseTotal: number;
  total: number;
  discountTotal: number;
  itemsTotalWithoutTaxes: number;
  paymentGatewayUsed: string;
  currency: string;
};

type CartResponse = {
  cart: Cart;
};
export const CartContext: React.FC = () => {
  useEffect(() => {
    setSnipcartEvents();
  }, []);

  function setSnipcartEvents() {
    const snipcart = window.Snipcart;
    const fbq = window.fbq;

    snipcart.events.on("item.adding", (parsedCartItem: AddedItem) => {
      console.log("added item", parsedCartItem);
      if (fbq)
        fbq("track", "AddToCart", {
          value: parsedCartItem.price,
          currency: "usd",
        });
    });
    snipcart.events.on("summary.checkout_clicked", () => {
      if (fbq) fbq("track", "ViewContent");
    });
    snipcart.events.on(
      "cart.confirmed",
      (cartConfirmResponse: CartResponse) => {
        console.log("purchased", cartConfirmResponse);
        if (fbq)
          fbq("track", "Purchase", {
            value: cartConfirmResponse.cart.total,
            currency: cartConfirmResponse.cart.currency,
          });
      }
    );
  }

  return <Helmet></Helmet>;
};
